import React from "react";

let templates = {
  FA: "Hello, this is the fire alarm template",
};

function JobDescriptionTemplates(props) {
  function insertTemplate(name) {
    let value = "";

    if (name === "FA") {
      value = `Smoke Alarm Install:\n${props?.primaryData?.comments2 || ""}`;
    } else if (name === "EICR") {
      value = `Carry out EICR to property: ≤6 circuits (£180) + X additional circuits @ £20.`;
    } else if (name === "EICR_and_PAT") {
      value =
        "Carry out EICR to property: ≤6 circuits (£180) + X additional circuits @ £20.\nCarry out PAT to property: ≤6 items (£60) + X items @ £2.00.";
    } else if (name === "PAT") {
      value = "Carry out PAT to property: ≤6 items (£60) + X items @ £2.00.";
    }

    props.handleFormDetails({
      target: {
        name: "details",
        value,
      },
    });
  }

  return (
    <div className="jdTemplates">
      <button onClick={() => insertTemplate("FA")}>F/A</button>
      <button onClick={() => insertTemplate("EICR")}>EICR</button>
      <button onClick={() => insertTemplate("PAT")}>PAT</button>
      <button onClick={() => insertTemplate("EICR_and_PAT")}>EICR & PAT</button>
    </div>
  );
}

export default JobDescriptionTemplates;
